import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import CapitalNeedPage from './pages/CapitalNeedPage';
import CapitalNeedExcelImportPage from './pages/CapitalNeedExcelImportPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="/error/not-found" replace />,
  },
  {
    path: 'new',
    element: <CapitalNeedPage />,
  },
  {
    path: 'new-excel-import',
    element: <CapitalNeedExcelImportPage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <CapitalNeedPage />,
      },
    ],
  },
];

export default routes;
